// extracted by mini-css-extract-plugin
export default {"blockHalf":"halfInfoBlock_blockHalf__Ayt4h","description":"halfInfoBlock_description__2YINo","data":"halfInfoBlock_data__tqr-j"};